import Cookies from 'js-cookie'

const TokenKey = 'userInfo'

const Id = 'id' // 用户id

const Unread = 'unread' // 未读消息

// token
export function getToken () {
  return Cookies.get(TokenKey)
}

export function setToken (token, expire) {
  console.log(token)
  // 将要设置的到期时间字符串转换为日期对象
  const expiryDate = new Date(expire)

  return Cookies.set(TokenKey, token, { expires: expiryDate })
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}

// 用户id
export function getId () {
  return Cookies.get(Id)
}

export function setId (id) {
  return Cookies.set(Id, id)
}

export function removeId () {
  return Cookies.remove(Id)
}

// 未读消息
export function getUnread () {
  return Cookies.get(Unread)
}

export function setUnread (value) {
  return Cookies.set(Unread, value)
}

export function removeUnread () {
  return Cookies.remove(Unread)
}
